import React from 'react';
import { Table } from 'semantic-ui-react';
import localization from '../../../../locales/localization';

export default class UslugaHeaderCells extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Table.HeaderCell textAlign="center" collapsing>
                    {localization.common.kolicina}
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" collapsing>
                    {localization.usluga.jedinicnaCijena}
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" collapsing>
                    {localization.radniNalog.cijenaUsluge}
                </Table.HeaderCell>
            </React.Fragment>
        );
    }
}
